/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The helper to correctly parse money string to float
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

export const parseMoneyToFloat = (value: string) => parseFloat(value.replace(',', '.'));
